<template>
  <v-content class="login-view">
    <v-row
      justify="center"

      class="login fill-height"
    >
      <transition name="fade">
        <v-col
          cols="12"
          md="5"
          lg="4"
          xl="3"
          class="pa-0"
        >
          <v-row justify="center">
            <StLogo />
          </v-row>

          <v-form
            ref="form"
            v-model="valid"
            class="login__card elevation-1 pa-6 mt-12"
            lazy-validation
            @submit="login"
          >
            <StInputComponent
              id="username"
              v-model="username"
              dark
              component="v-text-field"
              prepend-icon="mdi-account"
              name="login"
              :rules="emailRules"
              :label="i18n.email"
              type="text"
              :trim="true"
              :disabled="loading"
              required
            />
            <StInputComponent
              id="password"
              v-model="password"
              dark
              component="v-text-field"
              prepend-icon="mdi-lock"
              :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[v => !!v || i18n.passwordIsRequired]"
              name="password"
              :label="i18n.password"
              :type="showPass ? 'text' : 'password'"
              required
              :disabled="loading"
              @click:append="showPass = !showPass"
            />

            <v-row
              justify="end"
              class="no-gutters"
            >
              <v-btn
                color="primary"
                class="mx-0 my-2 login-view-button"
                :loading="loading"
                rounded
                large
                @click="login"
              >
                {{ i18n.enter }}
              </v-btn>
            </v-row>
          </v-form>
        </v-col>
      </transition>
    </v-row>
  </v-content>
</template>

<script>
import StInputComponent from '@stilingue/st-input-component';
import StLogo from '@stilingue/st-logo';
import { validateEmail, requiredRule } from '@stilingue/st-form-rules-utils';

export const ENTER_KEY_CODE = 13;

export default {
  name: 'StLogin',
  components: {
    StInputComponent,
    StLogo
  },
  props: {
    i18n: {
      type: Object,
      default: () => ({
        email: 'Email',
        password: 'Senha',
        enter: 'Entrar',
        emailIsRequired: 'E-mail não pode ser vazio',
        emailIsInvalid: 'E-mail não válido',
        passwordIsRequired: 'Senha não pode ser vazia'
      })
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showLoginForm: false,
      valid: false,
      showPass: false,
      username: '',
      password: '',
      emailRules: [
        requiredRule(this.i18n.emailIsRequired),
        validateEmail(this.i18n.emailIsInvalid)
      ]
    };
  },
  mounted() {
    /* istanbul ignore next  */
    window.addEventListener('keyup', this.handleKeyUp);
  },
  destroyed() {
    /* istanbul ignore next  */
    window.removeEventListener('keyup', this.handleKeyUp);
  },
  methods: {
    handleKeyUp(event) {
      if (
        event.key === 'Enter' ||
          event.key === 'NumpadEnter' ||
          event.keyCode === ENTER_KEY_CODE) {
        this.login();
      }
    },
    login() {
      if (this.$refs && this.$refs.form && this.$refs.form.validate()) {
        this.showPass = false;

        this.$emit('login', {
          username: this.username,
          password: this.password
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
  .login {
    padding-top: 15vh;
  }

  .login-view {
    background-color: var(--gray-050);

    &-button {
      min-width: 125px !important;
    }
  }

  .login__logo {
    margin: 0 auto 20px;
  }

  .login__card {
    background-color: var(--gray-100);
  }

  ::v-deep {
    @-webkit-keyframes autofill {
      to {
        color: var(--gray-600);
        background: transparent;
      }
    }

    input:-webkit-autofill {
      -webkit-animation-name: autofill;
      -webkit-animation-fill-mode: both;
    }

    .v-input--is-disabled input:-webkit-autofill {
      -webkit-animation-name: autofill;
      -webkit-animation-fill-mode: both;
    }
  }

</style>
